/**
 * Initialize Swiper sliders for logo carousel
 */

/* global Swiper, setTimeout, clearTimeout */

document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelectorAll('.logo-carousel-container').length) {
    return;
  }

  const partnersContainer = document.querySelector('.partners-search');
  if (partnersContainer) {
    const partnersField = partnersContainer.querySelector('input[type="text"]');
    if (partnersField) {
      partnersField.placeholder = 'Search All Corporate Partners';
    }
  }

  const programsContainer = document.querySelector('.programs-search');
  if (programsContainer) {
    const programsField = programsContainer.querySelector('input[type="text"]');
    if (programsField) {
      programsField.placeholder = 'Search All Programs';
    }
  }

  const sliderLogos = document.querySelectorAll('.logo-carousel-container');

  sliderLogos.forEach((logo, index) => {
    const logoId = `logo-slider-${index}`;

    logo.id = logoId;
    logo.classList.add('swiper');

    // Restructure for Swiper
    const figures = Array.from(logo.querySelectorAll('figure'));
    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    figures.forEach((fig) => {
      fig.classList.add('swiper-slide');
      wrapper.appendChild(fig);
    });

    logo.appendChild(wrapper);

    // Count slides and calculate how many to show
    const slideCount = figures.length;
    const desktopWideSlides = Math.min(slideCount - 1, 6); // Max 6, or less if fewer slides
    const desktopSlides = Math.min(slideCount, 4); // Max 6, or less if fewer slides
    const tabletSlides = Math.min(slideCount, 3); // Max 3, or less if fewer slides

    let swiper = null;
    let resizeTimer;

    // Function to check if Swiper should be active based on screen size and slide count
    const shouldInitSwiper = () => {
      const screenWidth = window.innerWidth;

      // Desktop: need 5 or more slides
      if (screenWidth >= 1024) {
        return slideCount >= 5;
      }

      // Mobile/Tablet: need more than 3 slides
      return slideCount > 3;
    };

    // Function to initialize or destroy Swiper
    const handleSwiper = () => {
      if (shouldInitSwiper()) {
        if (!swiper) {
          swiper = new Swiper(`#${logoId}`, {
            loop: true,
            autoplay: {
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
            slidesPerView: 3,
            spaceBetween: 48,
            breakpoints: {
              640: {
                slidesPerView: tabletSlides,
                spaceBetween: 60,
              },
              1024: {
                slidesPerView: desktopSlides,
                spaceBetween: 90,
              },
              1500: {
                slidesPerView: desktopWideSlides,
                spaceBetween: 150,
              },
            },
          });
        }
      } else {
        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
      }
    };

    handleSwiper();

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        handleSwiper();
      }, 250);
    });
  });
});
